import { SubmissionError } from 'redux-form'
import set from 'lodash-es/set'
import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/GenerateAPIDConstants'

export const submitGenerateAPID = dataToSend => async dispatch => {
  try {
    dispatch({ type: c.SUBMIT_GENERATE_APID_PENDING })
    const { data } = await axios.post(
      `${Config.API_URL}/unclaimed-student/registration/education-periods/${dataToSend.educationPeriodCd}`,
      dataToSend
    )
    await dispatch({
      type: c.SUBMIT_GENERATE_APID_FULFILLED,
      payload: data,
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.SUBMIT_GENERATE_APID_REJECTED, payload: errMsg })
    // Validation errors will be returned with the first word of the message
    // as the field name with the error and the rest as the actual validation
    // error.
    const formFields = Object.values(c.GENERATE_APID_FORM_FIELDS)
    const indexFirstSpace = errMsg.indexOf(' ')
    const errorField = errMsg.substring(0, indexFirstSpace)
    let error = ''
    if (formFields.includes(errorField)) {
      error = errMsg.substring(indexFirstSpace + 1)
      throw new SubmissionError(set({}, errorField, error))
    } else {
      throw new SubmissionError({ _error: errMsg })
    }
    // if (Object.keys(errMsg) > 0) {
    //   throw new SubmissionError(errMsg)
    // } else {
    //   throw new SubmissionError({ _error: errMsg })
    // }
  }
}

export const fetchGeneratedAPIDs = () => async dispatch => {
  try {
    dispatch({ type: c.FETCH_GENERATED_APIDS_PENDING })
    const { data } = await axios.get(`${Config.API_URL}/unclaimed-student/registrations`)
    await dispatch({
      type: c.FETCH_GENERATED_APIDS_FULFILLED,
      payload: { data },
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_GENERATED_APIDS_REJECTED, payload: errMsg })
  }
}
